import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { BOOK_PAGES, BOOK_TITLE, ESTIMATED_READ } from "../data/bookData";

export const BookPreview = () => (
  <section data-testid="book-preview-section" className="px-6 py-24 sm:py-32">
    <div className="mx-auto max-w-3xl">
      <div className="text-center">
        <p className="font-hand text-2xl text-[#C87D87]">the main gift</p>
        <h2 className="mt-3 font-display text-2xl font-semibold sm:text-3xl lg:text-4xl">{BOOK_TITLE}</h2>
        <p className="mt-4 inline-flex items-center gap-2 text-xs font-medium text-[#4A2E35]/60">
          <Clock size={13} /> {BOOK_PAGES.length} pages · about a {ESTIMATED_READ} read · best enjoyed with the music on
        </p>
      </div>

      <div className="paper-card deckle mt-12 divide-y divide-[#E8B4B8]/25">
        {BOOK_PAGES
          .map((p, i) => ({ label: p.title?.split(" — ")[0], page: i + 1 }))
          .filter((c, i, arr) => c.label && arr.findIndex((q) => q.label === c.label) === i)
          .map((c) => (
          <Link
            key={c.page}
            to={`/read?page=${c.page}`}
            data-testid={`toc-page-${c.page}`}
            className="group flex items-baseline gap-4 px-6 py-4 transition-colors hover:bg-[#FAE3E8]/40 sm:px-10"
          >
            <span className="font-display text-sm italic text-[#C87D87]">p. {c.page}</span>
            <span className="flex-1 text-sm font-medium transition-transform group-hover:translate-x-1 sm:text-base">{c.label}</span>
            <ArrowRight size={15} className="text-[#C87D87] opacity-0 transition-opacity group-hover:opacity-100" />
          </Link>
        ))}
      </div>

      <div className="mt-10 text-center">
        <Link
          to="/read"
          data-testid="preview-enter-reader-btn"
          className="inline-flex items-center gap-2.5 rounded-full bg-[#4A2E35] px-8 py-4 text-sm font-semibold text-[#FAF6EE] shadow-lg transition-all hover:-translate-y-0.5 hover:bg-[#362428]"
        >
          Begin at Page One
          <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  </section>
);
